// extracted by mini-css-extract-plugin
module.exports = {"font_red":"ProjectPayments_font_red__2-3MT","downloadButton":"ProjectPayments_downloadButton__1elfU"};